import { CompanyUserEmployeeRoleInput } from './companyUserEmployeeRole.input';
export class CompanyUserEmployeeRolesInput {
    companyUserEmployeeRoles: CompanyUserEmployeeRoleInput[];
}